import { useState } from "react";
import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { ComplaintBookAPIDataSourceImpl } from "../../Data/Datasource/API/ComplaintBookAPIDataSource";
import { ComplaintBookRepositoryImpl } from "../../Data/Repository/ComplaintBookRepositoryImpl";
import { ComplaintBook } from "../../Domain/Model/ComplaintBook";
import { ComplaintBooks } from "../../Domain/Model/ComplaintBooks";
import { GetComplaintBookById } from "../../Domain/UseCase/GetComplaintBookById";
import { GetComplaintBooks } from "../../Domain/UseCase/GetComplaintBooks";



export default function ComplaintBookViewModel() {
    const [complaintBooks, setComplaintBooks] = useState<ComplaintBooks[]>([]);
    const [complaintBookData, setComplaintBookData] = useState<ComplaintBook>();
    
    const complaintBookDataSourceImpl = new ComplaintBookAPIDataSourceImpl();
    const complaintBookRepositoryImpl = new ComplaintBookRepositoryImpl(complaintBookDataSourceImpl);

    const getComplaintBooksUseCase = new GetComplaintBooks(complaintBookRepositoryImpl);
    const getComplaintBookByIdUseCase = new GetComplaintBookById(complaintBookRepositoryImpl);

    async function getComplaintBooks(page: number, size: number, search: string): Promise<{ items: ComplaintBooks[]; totalCount: number }> {
        //setCustomers(await getCustomersUseCase.invoke());

        try {
            const result: PaginationResult<ComplaintBooks> = await getComplaintBooksUseCase.invoke(page, size, search );
        
            await setComplaintBooks(result.items); // Si quieres mantenerlo en el ViewModel
            
        
            return {
                items: result.items,
                totalCount: result.totalCount, // usar totalCount según tu interfaz
            };
        } catch (error) {
            console.error("Error al obtener Clientes:", error);
            return { items: [], totalCount: 0 };
        }
    }

    async function getComplaintBookById(itemId: number){
      try {
          const data = await getComplaintBookByIdUseCase.invoke(itemId);
          if(data){
            setComplaintBookData(data);
            console.log('data:', data)
           return data;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    return {
       getComplaintBooks,
       complaintBooks,
       getComplaintBookById,
       complaintBookData
      };
}